import { Card, Image, SimpleGrid, Stack, Text, Title } from "@mantine/core";

const sources = [
  {
    name: "Core Data",
    description:
      "Comprehensive European datasets covering economics, demographics, and policy indicators. Trusted by researchers and policymakers across the continent.",
    coverImage: "/data/discover/covers/core-data.jpg",
    logo: "/data/discover/logos/eu.png",
  },
  {
    name: "data.europa.eu",
    description:
      "The official portal for European open data, providing access to thousands of datasets from EU institutions and member states. Your gateway to European transparency.",
    coverImage: "/data/discover/covers/data-europa.jpg",
    logo: "/data/discover/logos/eu.png",
  },
  {
    name: "Eurostat",
    description:
      "The statistical office of the European Union, delivering high-quality statistics and data on Europe. Essential for understanding European trends and patterns.",
    coverImage: "/data/discover/covers/eurostat.jpg",
    logo: "/data/discover/logos/eurostat.png",
  },
  {
    name: "EU Open Data Portal",
    description:
      "Access to open data published by EU institutions and bodies. Promoting transparency, innovation, and accountability through data sharing.",
    coverImage: "/data/discover/covers/eu-open-data.jpg",
    logo: "/data/discover/logos/eu-data.png",
  },
];

export function AuthoritativeSources() {
  return (
    <Stack gap="xl">
      <Title order={2} fw={600} fz={28}>
        Authoritative Sources
      </Title>
      <Text c="gray.9" fz={16} lh={1.6}>
        Access trusted, verified data from Europe's most reliable sources. These
        institutions provide the foundation for evidence-based decision making
        and research.
      </Text>
      <SimpleGrid cols={{ base: 1, sm: 2 }} spacing="lg">
        {sources.map((source) => (
          <Card
            key={source.name}
            p={0}
            shadow="lg"
            radius="md"
            style={{ overflow: "hidden" }}
          >
            <Stack gap={0}>
              <Image
                src={source.coverImage}
                alt={source.name}
                height={140}
                style={{ objectFit: "cover", width: "100%" }}
              />
              <Stack gap="sm" p="lg" justify="flex-start">
                <Text fw={600} fz={18}>
                  {source.name}
                </Text>
                <Text c="gray.9" fz={15} lh={1.6}>
                  {source.description}
                </Text>
                <Image
                  src={source.logo}
                  alt={`${source.name} logo`}
                  width={120}
                  height={40}
                  fit="contain"
                  style={{ marginTop: "8px", height: 40, width: 120 }}
                />
              </Stack>
            </Stack>
          </Card>
        ))}
      </SimpleGrid>
    </Stack>
  );
}
